import React from 'react';
import { motion } from 'framer-motion';
export function OtlIntro() {
  return <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 mb-24" data-id="element-349" data-mp="2kuln6cl2iqdi">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.2
    }} data-id="element-350" data-mp="2kshm02ek05gx">
        <h3 className="font-serif text-2xl text-forest mb-4" data-id="element-351" data-mp="2bs2qybbsfc08">
          ¿Qué son los OTL?
        </h3>
        <div className="space-y-4 text-charcoal/80 font-light leading-relaxed" data-id="element-352" data-mp="1x2wq6ixaxdq8">
          <p data-id="element-353" data-mp="21xap2vb6a2zn">
            Los Objetos Territoriales Legales, conocidos como OTL, son elementos
            del territorio que han sido delimitados oficialmente mediante una
            norma, un acto administrativo o una decisión de una autoridad
            competente. Esta delimitación permite reconocer que en esos lugares
            existen condiciones especiales para su uso, manejo, protección o
            administración.
          </p>
          <p data-id="element-354" data-mp="3qosfkwn43n3t">
            Dicho de manera sencilla, un OTL no es solo una línea en un mapa, es
            una forma de identificar un área geográfica que tiene reglas claras
            y efectos reales para la vida de las personas, las comunidades, las
            empresas y las entidades públicas.
          </p>
          <p data-id="element-355" data-mp="3vnlr4jiu941c">
            Por ejemplo, cuando se delimita un páramo, una reserva forestal, una
            ronda hídrica o un humedal, también se establecen orientaciones
            sobre qué actividades se pueden realizar, cuáles deben limitarse y
            qué responsabilidades existen para proteger ese espacio.
          </p>
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.3
    }} data-id="element-356" data-mp="3gspg5yjna2kk">
        <h3 className="font-serif text-2xl text-forest mb-4" data-id="element-357" data-mp="2o8h6da50lytj">
          ¿Por qué son importantes?
        </h3>
        <div className="space-y-4 text-charcoal/80 font-light leading-relaxed" data-id="element-358" data-mp="n8c6jcxl23p8">
          <p data-id="element-359" data-mp="n69jn1rq8qoq">
            Los OTL ayudan a que la información geoespacial sea más clara,
            confiable y fácil de usar. Gracias a ellos, las entidades públicas
            pueden tomar mejores decisiones sobre conservación ambiental,
            ordenamiento territorial, gestión del suelo, planeación y protección
            de los recursos naturales.
          </p>
          <p data-id="element-360" data-mp="4arpgs1289f6">
            También son útiles para la ciudadanía, porque permiten conocer si un
            predio, una vereda, un municipio o una zona determinada hace parte
            de un área con reglas ambientales o territoriales específicas. Esto
            facilita la consulta de información oficial y contribuye a prevenir
            conflictos por el uso del suelo.
          </p>
          <p data-id="element-361" data-mp="1pm1aj6g9hokg">
            En la práctica, los OTL permiten responder preguntas como: ¿esta
            zona tiene alguna restricción ambiental?, ¿qué entidad administra
            esta figura?, ¿qué norma la creó?, ¿cuáles son sus límites?, ¿qué
            responsabilidades existen para su conservación?
          </p>
        </div>
      </motion.div>
    </div>;
}